( function ( $ ) {
	var $courseFilter = $(".courses-filters");

  var $courses = $('.course');
  var $dayWrappers = $('.day-wrapper');
  var filters = {
    level: '',
    ageGroup: '',
    weekDay: ''
  };

  function applyFilters() {
    const activeSessionId = $courseFilter.find('.filter.active').data('session-id');

    $courses.each(function () {
      const $course = $(this);
      const courseLevels = ($course.data('level') || '').split(',').map(s => s.trim());
      const courseAgeGroups = ($course.data('age-group') || '').split(',').map(s => s.trim());
      const courseSessionClass = `course-session-${activeSessionId}`;

      const matchSession = $course.hasClass(courseSessionClass);
      const matchLevel = !filters.level || courseLevels.includes(filters.level);
      const matchAge = !filters.ageGroup || courseAgeGroups.includes(filters.ageGroup);

      if (matchSession && matchLevel && matchAge) {
        $course.removeClass('filtered-out');
      } else {
        $course.addClass('filtered-out');
      }
    });

    let anyDayVisible = false;
    $dayWrappers.each(function () {
      const wrapper = $(this);
      const day = wrapper.data("day");
      const visibleCourses = wrapper.find('.course').not('.filtered-out');
      const hasVisibleCourses = visibleCourses.length > 0;

      if (filters.weekDay !== '') {
        if (day === filters.weekDay && hasVisibleCourses) {
          wrapper.show();
          visibleCourses.show();
          wrapper.find('.course.filtered-out').hide();
          anyDayVisible = true;
        } else {
          wrapper.hide();
        }
      } else {
        if (hasVisibleCourses) {
          wrapper.show();
          visibleCourses.show();
          wrapper.find('.course.filtered-out').hide();
          anyDayVisible = true;
        } else {
          wrapper.hide();
        }
      }
    });

    // toggle message based on visibility
    if (!anyDayVisible) {
      $('.no-courses-message').addClass('show');
    } else {
      $('.no-courses-message').removeClass('show');
    }
  }

  // read URL params into your filters + active session on load
  function readStateFromURL() {
    const params = new URLSearchParams(window.location.search);
    // session
    const sessionId = params.get('session');
    if (sessionId) {
      $courseFilter
        .find(`.filter`)
        .addClass('not-active').removeClass('active')
        .filter(`[data-session-id="${ sessionId }"]`)
        .removeClass('not-active').addClass('active');
    }
    // selects
    filters.level    = params.get('level')     || '';
    filters.ageGroup = params.get('ageGroup')  || '';
    filters.weekDay  = params.get('weekDay')   || '';

    $('#filter-level').val(filters.level);
    $('#filter-age-group').val(filters.ageGroup);
    $('#filter-week-day').val(filters.weekDay);

    applyFilters();
  }

  // write current state into URL + history
  function writeStateToURL(replace = false) {
    const params = new URLSearchParams();
    const sess = $courseFilter.find('.filter.active').data('session-id');
    if (sess) params.set('session', sess);
    if (filters.level) params.set('level',    filters.level);
    if (filters.ageGroup) params.set('ageGroup', filters.ageGroup);
    if (filters.weekDay)  params.set('weekDay',  filters.weekDay);

    const newUrl = `${location.pathname}?${params.toString()}`;
    if (replace) {
      history.replaceState(params.toString(), '', newUrl);
    } else {
      history.pushState(params.toString(), '', newUrl);
    }
  }

  if ($(".courses").length > 0) {
    // hook into clicks + selects
    $courseFilter.find(".filter").on("click", function(e){
      e.preventDefault();
      $courseFilter.find(".filter")
        .addClass("not-active").removeClass("active");
      $(this).removeClass("not-active").addClass("active");

      applyFilters();
      writeStateToURL();
    });

    $('#filter-level').on('change', function(){
      filters.level = $(this).val();
      applyFilters();
      writeStateToURL();
    });

    $('#filter-age-group').on('change', function(){
      filters.ageGroup = $(this).val();
      applyFilters();
      writeStateToURL();
    });

    $('#filter-week-day').on('change', function(){
      filters.weekDay = $(this).val();
      applyFilters();
      writeStateToURL();
    });

    // initial setup
    $(document).ready(function(){
      // set initial active tab to first, then override with URL if present
      $courseFilter.find(".filter").addClass("not-active");
      $courseFilter.find(".filter:first-child")
        .removeClass("not-active").addClass("active");

      readStateFromURL();
      writeStateToURL(true);
    });

    Array.prototype.remove = function() {
      let what, a = arguments, L = a.length, ax;
      while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
          this.splice(ax, 1);
        }
      }
      return this;
    };
  }

} )( jQuery );
